import { Paper, styled } from '@mui/material';

/** Full-width header image wrapper used above the form paper */
export const FormHeaderWrapper = styled('div')({
  padding: '0',
  textAlign: 'center',
});

/** Responsive header image that fills the wrapper width */
export const FormHeaderImage = styled('img')({
  width: '100%',
  maxWidth: '900px',
  marginBottom: '0',
  display: 'block',
  margin: '0 auto',
});

/** Paper card with a red gradient top border, used as the main form container */
export const FormPaper = styled(Paper)(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(4),
  maxWidth: 900,
  margin: '0 auto',
  borderTop: `4px solid ${theme.palette.primary.main}`,
  borderRadius: 0,
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '4px',
    background: `linear-gradient(to right, ${theme.palette.primary.main}, ${theme.palette.primary.light})`,
  }
}));

/** Semi-transparent overlay shown during form submission */
export const FormLoadingOverlay = styled('div')({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(255, 255, 255, 0.7)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex: 10,
  borderRadius: 0,
});
